// extracted by mini-css-extract-plugin
module.exports = {"phj04a2":"phj04a2","t1n9r5nh":"t1n9r5nh"};